var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"baaderbank-trades-container",attrs:{"fluid":""}},[_c('h1',[_vm._v("Baaderbank Trade's State Management")]),_vm._v(" "),(_vm.trades)?_c('BaaderbankConfirmTrades',{attrs:{"trades":_vm.trades,"loading":_vm.loading}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19090e39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/trades/BaaderbankConfirmTradesView.vue
// module id = null
// module chunks = 